var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import HttpStatus from "http-status-codes";
import { call, put, select, takeLatest } from "redux-saga/effects";
import logger from "../../logger";
import * as loggerTypes from "../../logger/logger.types";
import * as socketActions from "../../redux/socket/socket.actions";
import * as authActionsV2 from "../../reduxV2/auth/auth.actions";
import * as authSelectors from "../../reduxV2/auth/auth.selectors";
import * as authUtils from "../../reduxV2/auth/auth.utils";
import { showAlert } from "../../utils/alert/alert.utils";
import { cancelPendingCalls } from "../../utils/api/api.utils";
import { getGeneralUpdateSuccessText, getLocalizedText, } from "../../utils/i18n/i18n.utils";
import * as contactActions from "../contact/contact.actions";
import { updateContact } from "../contact/contact.api";
import { EContactCustomId } from "../contact/contact.types";
import * as authActions from "./auth.actions";
import * as authApi from "./auth.api";
import { getUser, updateUser, updateUserById, removeProfile, } from "./auth.api";
import * as authSelectorsV1 from "./auth.selectors";
// Sentry counts affected users by id, so an issue with no id on its events reports
// "Users Impacted: 0" however many events it has. The email is what makes an issue searchable
// by person. setValue merges into the existing user, so both survive.
var setLoggerUser = function (user) {
    logger.setValue({
        type: loggerTypes.EValueType.UserId,
        value: user.id,
    });
    logger.setValue({
        type: loggerTypes.EValueType.UserEmail,
        value: user.email || "",
    });
};
function signUpStartFlow(action) {
    var payload, locale, platform, firstname, lastname, email, phone, password, captcha, captchaVersion, captchaEnterprisePlatform, role, tac, signUpResponse, user, unknownError_1, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, , 8]);
                locale = payload.locale, platform = payload.platform, firstname = payload.firstname, lastname = payload.lastname, email = payload.email, phone = payload.phone, password = payload.password, captcha = payload.captcha, captchaVersion = payload.captchaVersion, captchaEnterprisePlatform = payload.captchaEnterprisePlatform, role = payload.role;
                return [4 /*yield*/, call(authApi.getTac, locale, platform)];
            case 2:
                tac = _a.sent();
                return [4 /*yield*/, call(authApi.signUp, {
                        locale: locale,
                        tacId: tac.id,
                        firstname: firstname,
                        lastname: lastname,
                        unverifiedPhone: phone,
                        unverifiedEmail: email,
                        password: password,
                        captcha: captcha,
                        captchaVersion: captchaVersion,
                        captchaEnterprisePlatform: captchaEnterprisePlatform,
                    })];
            case 3:
                signUpResponse = (_a.sent()).data;
                user = signUpResponse.data;
                return [4 /*yield*/, put(authActions.signUp.actions.success({ user: user }))];
            case 4:
                _a.sent();
                return [4 /*yield*/, call(authUtils.setUserType, user.id, role)];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                unknownError_1 = _a.sent();
                error = unknownError_1;
                logger.logError({ error: error });
                return [4 /*yield*/, put(authActions.signUp.actions.failure({ error: error }))];
            case 7:
                _a.sent();
                showAlert({
                    type: "error",
                    error: error,
                });
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function signUpVerifyPhoneStartFlow(action) {
    var payload, code, user, _a, _b, _c, _d, _e, data, _f, accessToken, refreshToken, unknownError_2, error, axiosError, wrongCodeMessage;
    var _g;
    return __generator(this, function (_h) {
        switch (_h.label) {
            case 0:
                payload = action.payload;
                _h.label = 1;
            case 1:
                _h.trys.push([1, 7, , 11]);
                code = payload.code;
                _c = (_b = authSelectors).getUser;
                return [4 /*yield*/, select()];
            case 2:
                _a = _c.apply(_b, [_h.sent()]);
                if (_a) return [3 /*break*/, 4];
                _e = (_d = authSelectorsV1).getUser;
                return [4 /*yield*/, select()];
            case 3:
                _a = _e.apply(_d, [_h.sent()]);
                _h.label = 4;
            case 4:
                user = _a;
                if (!user) {
                    throw new Error("No user");
                }
                return [4 /*yield*/, call(authApi.verifyPhone, user.id, code)];
            case 5:
                data = (_h.sent()).data;
                _f = data.data, accessToken = _f.accessToken, refreshToken = _f.refreshToken;
                return [4 /*yield*/, put(authActions.signUpVerifyPhone.actions.success({
                        accessToken: accessToken,
                        refreshToken: refreshToken,
                    }))];
            case 6:
                _h.sent();
                return [3 /*break*/, 11];
            case 7:
                unknownError_2 = _h.sent();
                error = unknownError_2;
                logger.logError({ error: error });
                axiosError = error;
                if (!(axiosError.isAxiosError &&
                    ((_g = axiosError.response) === null || _g === void 0 ? void 0 : _g.status) === HttpStatus.NOT_FOUND)) return [3 /*break*/, 9];
                wrongCodeMessage = getLocalizedText("intake.verification.pincode.wrong");
                return [4 /*yield*/, put(authActions.signUpVerifyPhone.actions.failure({
                        error: new Error(wrongCodeMessage),
                    }))];
            case 8:
                _h.sent();
                showAlert({
                    type: "error",
                    message: wrongCodeMessage,
                });
                return [2 /*return*/];
            case 9: return [4 /*yield*/, put(authActions.signUpVerifyPhone.actions.failure({ error: error }))];
            case 10:
                _h.sent();
                showAlert({
                    type: "error",
                    error: error,
                });
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function maybeSetDashboardType(user) {
    var currentDashboardType, _a, _b, userTypePreference, dashboardType;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _b = (_a = authSelectors).getSelectedDashboardType;
                return [4 /*yield*/, select()];
            case 1:
                currentDashboardType = _b.apply(_a, [_c.sent()]);
                if (!!currentDashboardType) return [3 /*break*/, 4];
                return [4 /*yield*/, call(authUtils.getUserType, user.id)];
            case 2:
                userTypePreference = _c.sent();
                dashboardType = authUtils.getDashboardPreference(userTypePreference, user.userType);
                return [4 /*yield*/, put(authActionsV2.setSelectedDashboardStart.getAction({ dashboardType: dashboardType }))];
            case 3:
                _c.sent();
                _c.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
function signUpVerifiedEmailStartFlow() {
    var user, unknownError_3, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 6]);
                return [4 /*yield*/, call(getUser)];
            case 1:
                user = _a.sent();
                // Set selectedDashboardType before user state updates to prevent a flash
                // of the pro dashboard when a tenant verifies their email during signup.
                return [4 /*yield*/, call(maybeSetDashboardType, user)];
            case 2:
                // Set selectedDashboardType before user state updates to prevent a flash
                // of the pro dashboard when a tenant verifies their email during signup.
                _a.sent();
                return [4 /*yield*/, put(authActions.getUser.actions.success(user))];
            case 3:
                _a.sent();
                setLoggerUser(user);
                if (user.unverifiedEmail) {
                    showAlert({
                        type: "error",
                        message: getLocalizedText("profile.email.unverified"),
                    });
                }
                return [3 /*break*/, 6];
            case 4:
                unknownError_3 = _a.sent();
                error = unknownError_3;
                logger.logError({ error: error });
                return [4 /*yield*/, put(authActions.getUser.actions.failure({ error: error }))];
            case 5:
                _a.sent();
                showAlert({
                    type: "error",
                    error: error,
                });
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function signUpResendVerificationEmailStartFlow() {
    var user, _a, _b, _c, _d, _e, unknownError_4, error;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                _f.trys.push([0, 5, , 6]);
                _c = (_b = authSelectors).getUser;
                return [4 /*yield*/, select()];
            case 1:
                _a = _c.apply(_b, [_f.sent()]);
                if (_a) return [3 /*break*/, 3];
                _e = (_d = authSelectorsV1).getUser;
                return [4 /*yield*/, select()];
            case 2:
                _a = _e.apply(_d, [_f.sent()]);
                _f.label = 3;
            case 3:
                user = _a;
                if (!user) {
                    throw new Error("No user");
                }
                if (!user.unverifiedEmail) {
                    // Nothing to resend (e.g. the email change was applied without requiring
                    // verification, so the response has no unverifiedEmail). Not a user-facing
                    // error, so return quietly instead of showing the generic error toast.
                    return [2 /*return*/];
                }
                return [4 /*yield*/, call(authApi.resendVerificationEmail, user.unverifiedEmail)];
            case 4:
                _f.sent();
                showAlert({
                    type: "info",
                    message: getLocalizedText("verify_email.info.description", {
                        email: user.unverifiedEmail,
                    }),
                });
                return [3 /*break*/, 6];
            case 5:
                unknownError_4 = _f.sent();
                error = unknownError_4;
                logger.logError({ error: error });
                showAlert({
                    type: "error",
                    error: error,
                });
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function signUpResendVerificationSmsStartFlow() {
    var user, _a, _b, _c, _d, _e, unknownError_5, error;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                _f.trys.push([0, 5, , 6]);
                _c = (_b = authSelectors).getUser;
                return [4 /*yield*/, select()];
            case 1:
                _a = _c.apply(_b, [_f.sent()]);
                if (_a) return [3 /*break*/, 3];
                _e = (_d = authSelectorsV1).getUser;
                return [4 /*yield*/, select()];
            case 2:
                _a = _e.apply(_d, [_f.sent()]);
                _f.label = 3;
            case 3:
                user = _a;
                if (!user) {
                    throw new Error("No user");
                }
                if (!user.unverifiedPhone) {
                    throw new Error("No unverified phone");
                }
                return [4 /*yield*/, call(authApi.resendVerificationSms, user.unverifiedPhone)];
            case 4:
                _f.sent();
                showAlert({
                    type: "info",
                    message: getLocalizedText("verify_sms.info.description", {
                        phone: user.unverifiedPhone,
                    }),
                });
                return [3 /*break*/, 6];
            case 5:
                unknownError_5 = _f.sent();
                error = unknownError_5;
                logger.logError({ error: error });
                showAlert({
                    type: "error",
                    error: error,
                });
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function getUserStartFlow(_) {
    var user, unknownError_6, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 6]);
                return [4 /*yield*/, call(getUser)];
            case 1:
                user = _a.sent();
                // Set selectedDashboardType if not already set — covers the phone-verification
                // signup path where the type is unknown until the user fetch completes.
                return [4 /*yield*/, call(maybeSetDashboardType, user)];
            case 2:
                // Set selectedDashboardType if not already set — covers the phone-verification
                // signup path where the type is unknown until the user fetch completes.
                _a.sent();
                return [4 /*yield*/, put(authActions.getUser.actions.success(user))];
            case 3:
                _a.sent();
                setLoggerUser(user);
                return [3 /*break*/, 6];
            case 4:
                unknownError_6 = _a.sent();
                error = unknownError_6;
                logger.logError({ error: error });
                return [4 /*yield*/, put(authActions.getUser.actions.failure({ error: error }))];
            case 5:
                _a.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
// Keep it only for signUp verify phone action
function genericSignInSuccessFlow(action) {
    var payload, accessToken, refreshToken, unknownError_7, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 7, , 8]);
                accessToken = payload.accessToken, refreshToken = payload.refreshToken;
                cancelPendingCalls();
                return [4 /*yield*/, call(authUtils.setAccessToken, accessToken)];
            case 2:
                _a.sent();
                return [4 /*yield*/, call(authUtils.setRefreshToken, refreshToken)];
            case 3:
                _a.sent();
                // Update V2 Redux hasAccessToken so withAuthenticationCheck allows access
                // after redirect. signUpVerifyPhoneSucceeded has no saga side effects.
                return [4 /*yield*/, put(authActionsV2.signUpVerifyPhoneSucceeded.getAction({
                        accessToken: accessToken,
                        refreshToken: refreshToken,
                    }))];
            case 4:
                // Update V2 Redux hasAccessToken so withAuthenticationCheck allows access
                // after redirect. signUpVerifyPhoneSucceeded has no saga side effects.
                _a.sent();
                return [4 /*yield*/, put(socketActions.openSocket.actions.start({}))];
            case 5:
                _a.sent();
                return [4 /*yield*/, put(authActions.getUser.actions.start({}))];
            case 6:
                _a.sent();
                return [3 /*break*/, 8];
            case 7:
                unknownError_7 = _a.sent();
                error = unknownError_7;
                logger.logError({ error: error });
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function rehydrateFlow(action) {
    var key, user, _a, _b, hasAccessToken, _c, _d, unknownError_8, error;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                key = action.key;
                _e.label = 1;
            case 1:
                _e.trys.push([1, 6, , 7]);
                // Handle both V1 ("auth") and V2 ("authV2") persist keys.
                // V2 persist was added in DEV-2657 — "authV2" fires after "auth" and is the
                // one where state.AUTH_V2.hasAccessToken is actually rehydrated.
                if (key !== "auth" && key !== "authV2") {
                    return [2 /*return*/];
                }
                _b = (_a = authSelectors).getUser;
                return [4 /*yield*/, select()];
            case 2:
                user = _b.apply(_a, [_e.sent()]);
                if (user) {
                    setLoggerUser(user);
                }
                _d = (_c = authSelectors).hasAccessToken;
                return [4 /*yield*/, select()];
            case 3:
                hasAccessToken = _d.apply(_c, [_e.sent()]);
                if (!hasAccessToken) return [3 /*break*/, 5];
                return [4 /*yield*/, put(socketActions.openSocket.actions.start({}))];
            case 4:
                _e.sent();
                _e.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                unknownError_8 = _e.sent();
                error = unknownError_8;
                logger.logError({ error: error });
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function updateUserStartStartFlow(action) {
    var payload, user, contact, onSuccess, updatedContact, updatedUser, unknownError_9, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                user = payload.user, contact = payload.contact, onSuccess = payload.onSuccess;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 10, , 12]);
                if (!(contact === null || contact === void 0 ? void 0 : contact.id)) return [3 /*break*/, 4];
                return [4 /*yield*/, call(updateContact, contact.id, contact)];
            case 2:
                updatedContact = (_a.sent()).data;
                return [4 /*yield*/, put(contactActions.updateContact.actions.success({
                        contactId: updatedContact.id,
                        contact: updatedContact,
                    }))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [4 /*yield*/, call(updateUser, user)];
            case 5:
                updatedUser = _a.sent();
                return [4 /*yield*/, put(authActions.updateUser.actions.success({
                        user: updatedUser,
                    }))];
            case 6:
                _a.sent();
                // The v2 update endpoint only returns the fields it accepts (see updateUser
                // in auth.api.ts), so the success payload above can be missing relations
                // like `broker` or computed fields like `hasCreateAccess`. Refetch the full
                // user so state.auth.user doesn't briefly show stale/incomplete data
                return [4 /*yield*/, put(authActions.getUser.actions.start({}))];
            case 7:
                // The v2 update endpoint only returns the fields it accepts (see updateUser
                // in auth.api.ts), so the success payload above can be missing relations
                // like `broker` or computed fields like `hasCreateAccess`. Refetch the full
                // user so state.auth.user doesn't briefly show stale/incomplete data
                _a.sent();
                return [4 /*yield*/, put(contactActions.getContact.actions.start({
                        contactId: EContactCustomId.MeMaster,
                    }))];
            case 8:
                _a.sent();
                return [4 /*yield*/, put(contactActions.getContact.actions.start({
                        contactId: EContactCustomId.Me,
                    }))];
            case 9:
                _a.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(updatedUser);
                showAlert({
                    type: "success",
                    message: getGeneralUpdateSuccessText("user"),
                });
                return [3 /*break*/, 12];
            case 10:
                unknownError_9 = _a.sent();
                error = unknownError_9;
                logger.logError({ error: error });
                return [4 /*yield*/, put(authActions.updateUser.actions.failure({ error: error }))];
            case 11:
                _a.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
function updateUserByIdStartStartFlow(action) {
    var payload, id, user, onSuccess, updateResponse, updatedUser, unknownError_10, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                id = payload.id, user = payload.user, onSuccess = payload.onSuccess;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(updateUserById, id, user)];
            case 2:
                updateResponse = (_a.sent()).data;
                updatedUser = updateResponse.data;
                return [4 /*yield*/, put(authActions.updateUserById.actions.success({
                        id: id,
                        user: updatedUser,
                    }))];
            case 3:
                _a.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(updatedUser);
                showAlert({
                    type: "success",
                    message: getGeneralUpdateSuccessText("user"),
                });
                return [3 /*break*/, 6];
            case 4:
                unknownError_10 = _a.sent();
                error = unknownError_10;
                logger.logError({ error: error });
                return [4 /*yield*/, put(authActions.updateUserById.actions.failure({ id: id, error: error }))];
            case 5:
                _a.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function removeProfileStartFlow(action) {
    var payload, onSuccess, unknownError_11, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                onSuccess = payload.onSuccess;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(removeProfile)];
            case 2:
                _a.sent();
                return [4 /*yield*/, put(authActions.removeProfile.actions.success({}))];
            case 3:
                _a.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                return [3 /*break*/, 6];
            case 4:
                unknownError_11 = _a.sent();
                error = unknownError_11;
                logger.logError({ error: error });
                return [4 /*yield*/, put(authActions.removeProfile.actions.failure({ error: error }))];
            case 5:
                _a.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function adminVerifyEmailStartFlow(action) {
    var payload, userId, data, unknownError_12, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 6]);
                userId = payload.userId;
                return [4 /*yield*/, call(authApi.adminVerifyEmail, userId)];
            case 2:
                data = (_a.sent()).data;
                return [4 /*yield*/, put(authActions.adminVerifyEmail.actions.success({
                        data: data,
                    }))];
            case 3:
                _a.sent();
                showAlert({
                    type: "success",
                    message: getGeneralUpdateSuccessText("user"),
                });
                return [3 /*break*/, 6];
            case 4:
                unknownError_12 = _a.sent();
                error = unknownError_12;
                logger.logError({ error: error });
                return [4 /*yield*/, put(authActions.adminVerifyEmail.actions.failure({ error: error }))];
            case 5:
                _a.sent();
                showAlert({
                    type: "error",
                    error: error,
                });
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function adminVerifyPhoneStartFlow(action) {
    var payload, userId, data, unknownError_13, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 6]);
                userId = payload.userId;
                return [4 /*yield*/, call(authApi.adminVerifyPhone, userId)];
            case 2:
                data = (_a.sent()).data;
                return [4 /*yield*/, put(authActions.adminVerifyPhone.actions.success({
                        data: data,
                    }))];
            case 3:
                _a.sent();
                showAlert({
                    type: "success",
                    message: getGeneralUpdateSuccessText("user"),
                });
                return [3 /*break*/, 6];
            case 4:
                unknownError_13 = _a.sent();
                error = unknownError_13;
                logger.logError({ error: error });
                return [4 /*yield*/, put(authActions.adminVerifyPhone.actions.failure({ error: error }))];
            case 5:
                _a.sent();
                showAlert({
                    type: "error",
                    error: error,
                });
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(authActions.signUp.types.START, signUpStartFlow)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.signUpVerifyPhone.types.START, signUpVerifyPhoneStartFlow)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.signUpVerifiedEmail.getType(), signUpVerifiedEmailStartFlow)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.adminVerifyEmail.types.START, adminVerifyEmailStartFlow)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.adminVerifyPhone.types.START, adminVerifyPhoneStartFlow)];
            case 5:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.signUpResendVerificationEmail.getType(), signUpResendVerificationEmailStartFlow)];
            case 6:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.signUpResendVerificationSms.getType(), signUpResendVerificationSmsStartFlow)];
            case 7:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.getUser.types.START, getUserStartFlow)];
            case 8:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.signUpVerifyPhone.types.SUCCESS, genericSignInSuccessFlow)];
            case 9:
                _a.sent();
                return [4 /*yield*/, takeLatest("persist/REHYDRATE", rehydrateFlow)];
            case 10:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.updateUser.types.START, updateUserStartStartFlow)];
            case 11:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.updateUserById.types.START, updateUserByIdStartStartFlow)];
            case 12:
                _a.sent();
                return [4 /*yield*/, takeLatest(authActions.removeProfile.types.START, removeProfileStartFlow)];
            case 13:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
// eslint-disable-next-line import/no-default-export
export default saga;
